import { useEffect, useState } from "react";
import { Modal, SelectInput } from "../../../../components";
import { useForm } from "react-hook-form";
import { setEstado } from "../handlers";

export default function CambiarEstado(estado) {
  const [rta, setRta] = useState({
    data: null,
    error: null,
    loading: false,
  });

  const estados = [
    { name: "Activo", id: 1, value: 1 },
    { name: "Inactivo", id: 2, value: 2 },
    { name: "Penalizado", id: 3, value: 3 },
  ];

  const enviar = async (e) => {
    setEstado(e, rta, setRta, estado.id);
  };

  useEffect(() => {
    if (rta.data != null && rta.error == null) {
      estado.state(rta.data.estado);
    }
  }, [rta]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();

  return (
    <Modal
      loading={rta.loading}
      show={estado.open}
      onHide={estado.setOpen}
      title={() => {
        return "Cambiar estado";
      }}
    >
      <form onSubmit={handleSubmit(enviar)}>
        <fieldset disabled={rta.loading}>
          <SelectInput
            data={estados}
            label={"Seleccione un estado"}
            value={estado.estado.id}
            valueName={estado.estado.estado}
            register={register}
            name={"estado"}
          />
          <button type="submit" className="btn btn-sm btn-primary mt-2 d-flex">
            Cambiar estado{" "}
            {rta.loading && (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-primary" role="status"></div>
              </div>
            )}
          </button>
        </fieldset>
      </form>
    </Modal>
  );
}
